import {StyleSheet} from 'react-native';

export default StyleSheet.create({
  scrollStyle: {
    flex: 1,
  },
  scroll: {
    flex: 1,
  },
  description: {
    marginBottom: 32,
  },
});
